const e = {
  getFiles: {
    schema: {
      method: "get",
      url: "/files"
    }
  },
  getFile: {
    schema: {
      method: "get",
      url: "/files/{id}"
    }
  }
};
export {
  e as filesService
};
